export function addQueryID(hit, queryID) {
  if (!queryID) {
    return hit;
  }
  return {
    ...hit,
    __queryID: queryID
  };
}